import PropTypes from 'prop-types';
import TourItineraryContent from '../../../../TravelOption/TourInformation/TourItinerary/TourItineraryContent';

const TourCompareTable = ({ tourTravelOptions }) => tourTravelOptions && tourTravelOptions.map(
  (travelOption) => (
    <TourItineraryContent
      key={travelOption?.itinerary?.uniqueKey}
      itinerary={travelOption.itinerary}
    />
  ),
);

TourCompareTable.propTypes = {
  tourTravelOptions: PropTypes.arrayOf(PropTypes.objectOf).isRequired,
};

export default TourCompareTable;
